import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

import useAnimate from './primitives/Motion';

/**
 * Hairline read-progress bar in the group's own colours:
 * the red / green / blue dashes from the badge.
 *
 * Behind the gate it renders as a plain element with no inline style.
 * That matters for the prerender: `useScroll` reads a document that has
 * never been laid out, so it produces an arbitrary progress value, and
 * baking that into the static HTML makes it disagree with the browser's
 * first render. The bar's resting scaleX(0) lives in CSS instead, so the
 * static page shows no progress rather than a full bar.
 */
export default function ScrollProgress() {
    const animate = useAnimate();
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 220, damping: 40, restDelta: 0.001 });

    if (!animate)
        return <div className="scroll-progress" aria-hidden="true" />;

    return <motion.div className="scroll-progress" style={{ scaleX }} aria-hidden="true" />;
}
